import axios, { AxiosError } from 'axios';
import axiosService from '../services/axios.service';
import { IFeedResponse } from '../datatypes/CommonTypes';

const commonApi = () => {
  const { getGuestHttpClient } = axiosService();

  const getPageContent = async (slug: string) => {
    return await getGuestHttpClient()
      .get('/page/' + slug)
      .then((response) => response.data.page);
  };

  const getStates = async () => {
    return await getGuestHttpClient()
      .get('/states')
      .then((response) => response.data.states);
  };

  const getCounties = async (state: string) => {
    return await getGuestHttpClient()
      .get(`/state-counties/${state}`)
      .then((response) => response.data.counties);
  };

  const getBlogXMLFeed = async (): Promise<IFeedResponse> => {
    //direct API call because the instances are not setup to call APIs / content of Old Site
    return await axios
      .get('https://www.blog.theuswillregistry.org/feed/', {
        responseType: 'text',
      })
      .then((response) => ({
        success: true,
        data: response.data,
        message: 'XML feed retrieved successfully',
      }))
      .catch((error) => ({
        success: false,
        message: (error as AxiosError).message,
      }));
  };

  const getPagesMetadata = async () => {
    return await getGuestHttpClient()
      .get('metadata')
      .then((response) => ({
        metadata: response.data.metadata,
        defaultMetadata: response.data.defaultMetadata,
      }))
      .catch(() => ({
        metadata: [],
        defaultMetadata: null,
      }));
  };

  return {
    getPageContent,
    getStates,
    getCounties,
    getBlogXMLFeed,
    getPagesMetadata,
  };
};

export default commonApi;
